import { render, staticRenderFns } from "./DetailsBatiment.vue?vue&type=template&id=40823d4a"
import script from "./DetailsBatiment.vue?vue&type=script&lang=js"
export * from "./DetailsBatiment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports